enum RouteName {
    HOME = 'home',
    LOGIN = 'login',
    STORE2STORE = 'store2store',
    PARCEL_OVERVIEW = 'parcelOverview',
    USER_OVERVIEW = 'userOverview',
    STORE_MANAGEMENT = 'storeManagement',
    PICKUP = 'pickup',
    CREATE_SHIPMENT = 'createShipment'
}

export default RouteName;
